import { render, staticRenderFns } from "./DealStat.vue?vue&type=template&id=20e1bbfc&scoped=true"
import script from "./DealStat.vue?vue&type=script&lang=js"
export * from "./DealStat.vue?vue&type=script&lang=js"
import style0 from "./DealStat.vue?vue&type=style&index=0&id=20e1bbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1bbfc",
  null
  
)

export default component.exports